import { Box, Typography } from "@mui/material";
import React from "react";
import mapFallBack from "assets/icons/mapFallBack.svg";

export default function MapFallBack() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      gap={2}
      py={4}
      height="100%"
    >
      <Typography
        sx={{ color: "#0A1D35", fontWeight: 600, fontSize: "1.5rem" }}
      >
        No Active drivers!
      </Typography>

      <Box
        component="img"
        src={mapFallBack}
        alt="Map fallback"
        sx={{ maxWidth: "100%", height: "auto", mt: 2 }}
      />
    </Box>
  );
}
